import { useEffect, useState } from 'react';
import { useParams} from 'react-router-dom'
import axios from 'axios'
import { AODetailComponent, AOResumeComponent } from '../GetAO'
import { DisplayStatusComponent } from './utils'



export const AOReadMatchDetailComponent = () => {

    const { key } = useParams();
    const [aoParsed, setAoParsed] = useState();

    useEffect(() => {
        if (!key) {
            return;
        }

        axios.get('/api/aoreadondemand/readao?key=' + key).then(response => {
            if (response.data) {
                setAoParsed(response.data);
            }
        })

    }, [key]);

    if (!key) {
        return <></>
    }


    var aoResult = <></>
    if (aoParsed) {
        aoResult = <><AOResumeComponent aoParsed={ aoParsed } /><AODetailComponent aoParsed={ aoParsed } /></>
    }

    return <div><DisplayStatusComponent calculKey={key} checkStatus={status => status.isParsed} errorMessageCheckStatus={"L'appel d'offre n'a pas pu être parsé"} /> { aoResult } </div>
}





